import { Box, Button, Paper, Typography } from '@mui/material';
import React from 'react';
import investorContactAllLang from '../langs/investorContactAllLang';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import HAppRoutes from '../../../../../app/features/routes/helpers/HAppRoutes';
import ContactRoutes from '../../../../contacts/ContactsRoutes';

const CContactDrawerAll = () => {
	const styles = {
		title: {
			fontWeight: '600',
			color: 'white',
		},
		identity: {
			padding: '0px 0px 0px 0px',
			fontSize: '15px',
			color: 'white',
			lineHeight: '1.5rem',
		},
	};

	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<>
			<Paper sx={{ marginBottom: '20px', padding: '15px', backgroundColor: 'rgba(42, 189, 187, 0.15)' }}>
				<Typography sx={styles.title}>{t(investorContactAllLang.title.tag)}</Typography>
				<Box sx={{ margin: '15px 0px', color: 'white', fontSize: '15px', lineHeight: '1.5rem' }}>
					{t(investorContactAllLang.description.tag)}
				</Box>
				<Button
					onClick={() => navigate(HAppRoutes.getPath(ContactRoutes.index.tag))}
					variant="contained"
					size="small"
					color="inherit"
					fullWidth
					sx={{ backgroundColor: 'white', color: '#1A2B48' }}
				>
					{t(investorContactAllLang.btn.tag)}
				</Button>
			</Paper>
		</>
	);
};

export default CContactDrawerAll;
